export const colors = [
    'rgb(113, 42, 153)',
    'rgb(172, 24, 24)',
    'rgb(245, 171, 28)',
    'rgb(200, 237, 226)',
    'rgb(235, 87, 87)',
    'rgb(48, 182, 143)',
    'rgb(93, 95, 239)',
    'rgb(0, 117, 82)',
    'rgb(166, 171, 189)',
    'rgb(218, 218, 234)',
    'rgb(239, 93, 168)',
    'rgb(24, 73, 59)',
    'rgb(86, 204, 242)',
    'rgb(67, 223, 204)',
    'rgb(141, 109, 25)',
];
